import React from "react";
import { Tabs, Tab } from "react-bootstrap";

type TabComponent = {
    title: string;
    element: React.ReactNode;
};

type Props = {
    tabs: TabComponent[];
    details1?: React.ReactNode;
    details2?: React.ReactNode;
};

const ModalTabs = (props: Props) => {
    if (!props.tabs) return null;

    return (
        <div className="modal-tabs">
            <div className="modal-tabs__details1">{props.details1}</div>
            <hr />
            <div className="modal-tabs__details2">{props.details2}</div>
            <div className="modal-tabs__tabs">
                <Tabs id="modal-tabs" defaultActiveKey={"operations0"} variant="tabs">
                    {props.tabs.map((tab, idx) => {
                        const eventKey = `operations${idx}`;
                        const { title, element } = tab;

                        return (
                            <Tab eventKey={eventKey} title={title} key={idx}>
                                {element}
                            </Tab>
                        );
                    })}
                </Tabs>
            </div>
        </div>
    );
};

export default ModalTabs;
